import { isCommunioApexHost, isCommunioProductSlugHost } from '@/platform/lib/authDomain';

/**
 * Share theme (and similar prefs) across apex + Free slug hosts.
 * Paydirt and localhost stay host-only.
 */
export function sharedCookieDomainForHost(hostname: string): string | undefined {
  const h = (hostname || '').trim().toLowerCase().replace(/\.$/, '');
  if (!h) return undefined;
  if (isCommunioApexHost(h) || isCommunioProductSlugHost(h)) {
    return '.communiosocial.com';
  }
  return undefined;
}
